<template>
	<v-menu v-model="menuOpen" :close-on-content-click="false" max-width="180" offset-y :disabled="disabled">
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				:value="displayValue"
				:placeholder="placeholder"
				prepend-inner-icon="mdi-clock-outline"
				append-icon="mdi-chevron-down"
				readonly
				:disabled="disabled"
				v-bind="attrs"
				v-on="on"
				outlined
				dense
				hide-details
				class="remove-bottom-details stp-activator"
			/>
		</template>
		<div class="stp-panel">
			<div class="stp-list" ref="list">
				<button
					v-for="time in times"
					:key="time"
					type="button"
					class="stp-item"
					:class="{ selected: time === value, disabled: isDisabled(time) }"
					:disabled="isDisabled(time)"
					@click="selectTime(time)"
				>
					{{ time }}
				</button>
			</div>
		</div>
	</v-menu>
</template>

<script>
export default {
	name: 'SimpleTimePicker',
	props: {
		value: { type: String, default: null }, // 'HH:mm'
		minTime: { type: String, default: null }, // 'HH:mm', times before this are blocked
		placeholder: { type: String, default: 'Seleccionar hora' },
		disabled: { type: Boolean, default: false },
		stepMinutes: { type: Number, default: 30 }
	},
	data() {
		return {
			menuOpen: false
		}
	},
	computed: {
		displayValue() { return this.value || '' },
		times() {
			const list = []
			for(let h = 0; h < 24; h++) {
				for(let m = 0; m < 60; m += this.stepMinutes) {
					list.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'))
				}
			}
			return list
		}
	},
	watch: {
		menuOpen(open) {
			if(open) this.$nextTick(() => this.scrollToSelected())
		}
	},
	methods: {
		isDisabled(time) {
			return !!this.minTime && time < this.minTime
		},
		selectTime(time) {
			if(this.isDisabled(time)) return
			this.$emit('input', time)
			this.menuOpen = false
		},
		scrollToSelected() {
			const list = this.$refs.list
			if(!list) return
			const target = this.value
				? list.querySelector('.stp-item.selected')
				: list.querySelector('.stp-item:not(.disabled)')
			if(target) target.scrollIntoView({ block: 'center' })
		}
	}
}
</script>

<style scoped>
.stp-activator /deep/ input {
	cursor: pointer;
	font-weight: 600;
}
.stp-panel {
	background: white;
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0,0,0,0.12);
	overflow: hidden;
	border: 1px solid #E5E7EB;
}
.stp-list {
	max-height: 220px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding: 6px;
	gap: 2px;
}
.stp-item {
	border: none;
	background: transparent;
	text-align: left;
	padding: 7px 12px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 500;
	color: #374151;
	cursor: pointer;
	transition: background 0.12s, color 0.12s;
}
.stp-item:hover:not(.disabled) { background: #EEF2FF; color: #2D4B95; }
.stp-item.selected { background: #2D4B95; color: white; }
.stp-item.disabled { color: #D1D5DB; cursor: not-allowed; }

/deep/ .remove-bottom-details .v-text-field__details { display: none; }
/deep/ .remove-bottom-details .v-input__slot { margin-bottom: 0; }
</style>